// dependencies
import React from "react";
import { useIntl } from "react-intl";

// components
import Text from "../../Text";

type PropsType = {
  advance: {
    maxDueDate: Date;
    amount: number;
  };
};

const EstimateAdvance: React.FunctionComponent<PropsType> = (props) => {
  const { advance } = props;

  const intl = useIntl();

  return (
    <Text>
      {intl.formatMessage(
        {
          defaultMessage:
            "Un acompte d’un montant de <price>{amount}</price> vous sera demandé après validation de votre réservation à l’étape suivante.",
        },
        {
          amount: intl.formatNumber(advance.amount, {
            style: "currency",
            currency: "EUR",
          }),
          price: (...chunks) => (
            <Text style={{ fontWeight: "700" }}>{chunks}</Text>
          ),
        }
      )}
    </Text>
  );
};

export default EstimateAdvance;
